import { z } from 'zod';

import { AppointmentBookStatus } from '@/models/appointment/Appointment.ts';

export const bookAppointmentSyncResponseSchema = z
    .object({
        status: z.enum([AppointmentBookStatus.BOOKED, AppointmentBookStatus.DECLINED]),
    })
    .loose();
